import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { NavHeader } from 'components/nav_header';
import MainLogo from 'assets/images/logos/sunset_skates_1.svg';
import { MainCarousel } from 'components/main_carousel';
import { Footer } from 'components/footer';
import { SEO } from 'components/seo';

const AboutPage: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });

  const logo = (
    <img
      src={MainLogo}
      alt="Sunset Skates"
      className="img-rounded img-responsive"
    />
  );

  return (
    <>
      <SEO pageTitle="About" />
      <div>
        <NavHeader />
        <div className="header-1">
          <div className="wrapper bg-white">
            <div className="content-center">
              <Container style={{ marginTop: 140, marginBottom: 100 }}>
                <Row>
                  <Col className="ml-auto mr-auto d-flex justify-content-center">
                    <h1 className="title h2 text-center text-lg-left">About</h1>
                  </Col>
                </Row>
                <Card className="card-plain card-blog">
                  <Row className="mb-lg-4">
                    <Col
                      lg="7"
                      className="d-flex align-items-center mb-5 mb-lg-0 order-2 order-lg-1"
                    >
                      <Card.Body>
                        <Card.Title as="h3" className="pl-4">
                          Sunset Skates
                        </Card.Title>
                        <p className="card-description pl-4">
                          Sunset Skates is a skateboarding school located in
                          Sunset Beach on the North Shore of Oahu. Our mission
                          is to teach skateboarding to students of all ages in a
                          fun, safe, and encouraging way! 🤙
                        </p>
                        <p className="card-description pl-4">
                          Sunset Skates will benefit the complete beginner by
                          giving them the skills and confidence they need to
                          safely learn how to skateboard. We also help build the
                          skills of more advanced students by encouraging
                          creativity and independent style.
                        </p>
                      </Card.Body>
                    </Col>
                    <Col lg="1" className="order-1 order-lg-2" />
                    <Col lg="3" className="my-4 my-lg-0 order-1 order-lg-2">
                      <div className="card-image px-4 px-lg-0">{logo}</div>
                    </Col>
                    <Col lg="1" className="order-1 order-lg-2" />
                  </Row>
                  <Row>
                    <Col
                      lg="7"
                      className="mt-lg-5 d-flex justify-content-center align-items-center"
                    >
                      <MainCarousel source="about" />
                    </Col>
                    <Col
                      lg="5"
                      className="d-flex align-items-center mb-5 mb-lg-0"
                    >
                      <Card.Body>
                        <Card.Title as="h3" className="pl-4">
                          Willy Akers
                        </Card.Title>
                        <p className="card-description pl-4 text-primary">
                          Willy Akers is the owner and main instructor at Sunset
                          Skates. Willy has 25 years of skateboarding
                          experience. Once a professional skateboarder,
                          skateboarding has taken him around the world
                          eventually landing him in Sunset Beach on the north
                          shore of Oahu with his wife and 2 young daughters.
                          Willy has a bachelor of fine arts with a focus on
                          education. His art background gives him a unique and
                          creative approach to skateboarding and teaching. He is
                          also a natural athlete able to teach both the art and
                          athleticism of skateboarding.
                        </p>
                        <p className="card-description pl-4 text-primary">
                          Willy really notices and focuses on his students
                          individual strengths building his students confidence
                          and individual style. Willy has experience teaching at
                          skateboarding camps such as Woodward and after school
                          programs in New York City. He is passionate about
                          sharing his love of skateboarding!
                        </p>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Container>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AboutPage;
